import { Alert, Spin, Table } from "antd";
import { getDownloadUrl } from "../utilities/download";
import { parse } from 'csv-parse/sync';
import { useQuery } from 'react-query';
import { fetchWithTimeout } from "../utilities/utilities";
import "./Preview.css"
import { ISelection, NotificationCallback } from "../types";
import { useMemo } from "react";

interface PreviewData {
  data: object[];
  columns: { title: string, dataIndex: string, key: string }[];
}

const fetchPreviewData = async (downloadUrl: string, notify: NotificationCallback, token: string): Promise<PreviewData> => {
  const request = fetchWithTimeout(downloadUrl, notify, token);
  const body = await request.fetch(r => r.text());

  const records: {info: {columns: [{name: string}]}, record: object}[] = parse(body, {
    columns: true,
    skip_empty_lines: true,
    info: true
  });

  if (records.length > 0) {
    const columns = records[0].info.columns.map(field => ({
      title: field.name,
      dataIndex: field.name,
      key: field.name
    }));

    const data = records.map(r => r.record);
    return { data, columns };
  } else {
    return { data: [], columns: [] };
  }
};

export function Preview(props: { query: ISelection, token: string, notify: NotificationCallback }) {
  const downloadUrl = useMemo(() => 
    getDownloadUrl({ ...props.query, limit: 500 }, props.token),
    [props.query, props.token]
  );

  const queryKey = useMemo(() => 
    ['preview', downloadUrl, props.token],
    [downloadUrl, props.token]
  );

  const { data: previewData, isLoading, error } = useQuery<PreviewData, Error>(
    queryKey,
    () => fetchPreviewData(downloadUrl, props.notify, props.token),
    {
      enabled: !!downloadUrl && !!props.token,
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );
  
  if (isLoading) {
    return <div>
        <Spin tip="Loading..." size="large" style={{marginTop: "5%"}}>
            <div className="content" />
        </Spin>
      </div>;
  }
  
  if (error) {
    console.log(error);
    return <Alert
          message="Error"
          description="An error occurred loading the page."
          type="error"
          showIcon
        />
  }
  
  if (previewData) {
    return <>
      <Table 
        scroll={{x: true}} 
        bordered={true} 
        dataSource={previewData.data} 
        columns={previewData.columns} 
        className="table-striped-rows"
      />
    </>;
  }
  
  return null;
}